<div class="row row-cols-1 row-cols-lg-2 pb-5">
  <div
    class="col col-lg-6 p-3 p-lg-4 rounded bg-white border border-3 text-dark mb-3 mb-lg-0"
    [class.mobile-brief-section]="!largeView"
  >
    <div class="row row-cols-auto gap-3">
      @if (selectedJobType?.id) {
        <div>
          <dl class="m-0">
            <dt>Job Type</dt>
            <dd>
              {{ selectedJobType?.name }}
            </dd>
          </dl>
        </div>
      }
      @if (otherJobType?.st?.data?.id) {
        <div (click)="currentStep = 1; editField('st')">
          <dl class="m-0">
            <dt>Service Type</dt>
            <dd class="link-edit">
              {{ otherJobType.st.value }}
            </dd>
          </dl>
        </div>
      }
      @if (otherJobType?.site?.data?.id) {
        <div (click)="currentStep = 1; editField('site')">
          <dl class="m-0">
            <dt>Site</dt>
            <dd class="link-edit">
              {{ otherJobType.site.value }} [{{ otherJobType.client.value }}]
            </dd>
          </dl>
        </div>
      }
      @if (otherJobType?.site?.data?.id) {
        <gtapp-site-keys
          [selectedSite]="otherJobType?.site?.data"
        ></gtapp-site-keys>
      }
      @if (
        selectedSiteExtraDetails?.information && otherJobType?.site?.data?.id
      ) {
        <div>
          <dl class="m-0">
            <dt>Site Information</dt>
            <dd class="gt-multi-line">
              {{ selectedSiteExtraDetails?.information }}
            </dd>
          </dl>
        </div>
      }
      @if (otherJobType?.assignee?.data?.id) {
        <div (click)="currentStep = 2; editField('assignee')">
          <dl class="m-0">
            <dt>Assignee</dt>
            <dd class="link-edit">
              <span
                (click)="$event.stopPropagation(); currentStep = 2"
                [gtappPopover]="userDetailPopoverTemplate"
                [popoverData]="{ userId: otherJobType?.assignee?.data?.id }"
              >
                {{ otherJobType?.assignee?.value }}
              </span>
            </dd>
          </dl>
        </div>
      }
      @if (formdata.value?.externalJobId) {
        <div (click)="currentStep = 3; shiftFocus('jobNumberField')">
          <dl class="m-0">
            <dt>Job Number</dt>
            <dd class="link-edit">{{ formdata.value?.externalJobId }}</dd>
          </dl>
        </div>
      }
      @if (formdata.value?.position) {
        <div (click)="currentStep = 3; shiftFocus('positionField')">
          <dl class="m-0">
            <dt>Shift Position</dt>
            <dd class="link-edit">{{ formdata.value?.position }}</dd>
          </dl>
        </div>
      }
      @if (otherJobType.ai.value) {
        <div (click)="currentStep = 3; shiftFocus('aiId')">
          <dl class="m-0">
            <dt>Additional Information</dt>
            <dd class="link-edit">{{ otherJobType.ai.value }}</dd>
          </dl>
        </div>
      }
      @if (otherJobType.in.value) {
        <div (click)="currentStep = 3; shiftFocus('inId')">
          <dl class="m-0">
            <dt>Internal Notes</dt>
            <dd class="link-edit">{{ otherJobType.in.value }}</dd>
          </dl>
        </div>
      }
    </div>
  </div>

  <div class="col px-lg-2">
    <form [formGroup]="formdata">
      <!-- Step 1: Select Site -->
      @if (currentStep === 1) {
        <div class="row row-cols-2 mb-2">
          <div class="col">
            <button
              type="button"
              class="btn btn-lg btn-dark w-100"
              [routerLink]="['/schedule']"
            >
              Cancel
            </button>
          </div>
          <div class="col">
            <button
              type="button"
              class="btn btn-lg btn-primary w-100"
              [disabled]="!otherJobType.site.data"
              (click)="
                currentStep = 2; shiftFocus('assigneeId'); getAssignees()
              "
            >
              Next
            </button>
          </div>
        </div>
        @if (selectedJobType?.type_identity === 1) {
          <div class="mb-2">
            @if (otherJobType.st.data?.id && !otherJobType.st?.search) {
              <div>
                <dl>
                  <div class="d-flex align-items-center">
                    <div class="flex-grow-1">
                      <dt>Service Type</dt>
                      <dd>
                        {{ otherJobType.st.value }}
                      </dd>
                    </div>
                    <div>
                      <span (click)="editField('st')" class="edit-button">
                        <span id="edit-button-placeholder d-none"></span
                      ></span>
                    </div>
                  </div>
                </dl>
              </div>
            }
            @if (!otherJobType.st.data?.id || otherJobType.st?.search) {
              <div>
                <gtapp-auto-complete
                  [data]="serviceTypeListData"
                  placeHolder="Service Type (Optional)"
                  searchKeyword="name"
                  [initialValue]="otherJobType?.st?.value"
                  [itemTemplate]="serviceTypeTemplate"
                  [addInitialKey]="isAdmin && otherJobType?.st?.tempValue"
                  (inputChanged)="onSTSearch($event)"
                  (selected)="onServiceTypeSelect($event)"
                  (blurTriggered)="blurTriggered('st')"
                  [enableCloseOption]="true"
                  (fieldCleared)="editField('st')"
                  [inputId]="'stId'"
                >
                </gtapp-auto-complete>
                <ng-template #serviceTypeTemplate let-item>
                  @if (item?.key === 0) {
                    <div>Add Service Type</div>
                  } @else {
                    <div>
                      {{ item.name }}
                    </div>
                  }
                </ng-template>
              </div>
            }
          </div>
        }

        @if (otherJobType.site.data?.id && !otherJobType.site?.search) {
          <div>
            <dl>
              <div class="d-flex align-items-center">
                <div class="flex-grow-1">
                  <dt>Site</dt>
                  <dd>
                    {{ otherJobType.site.value }}
                    <div>[{{ otherJobType.client.value }}]</div>
                  </dd>
                </div>
                <div>
                  <span (click)="editField('site')" class="edit-button">
                    <span id="edit-button-placeholder d-none"></span
                  ></span>
                </div>
              </div>
            </dl>
          </div>
        }
        @if (!otherJobType.site.data?.id || otherJobType.site?.search) {
          <div>
            <gtapp-auto-complete
              [data]="siteList"
              placeHolder="Select Site"
              searchKeyword="company_name"
              [initialValue]="formdata.value.siteName"
              [itemTemplate]="siteTemplate"
              [addInitialKey]="true"
              (inputChanged)="onSiteSearch($event)"
              (selected)="onSelectSite($event)"
              (blurTriggered)="blurTriggered('site')"
              [enableCloseOption]="true"
              (fieldCleared)="editField('site')"
              [inputId]="'siteId'"
            >
            </gtapp-auto-complete>
          </div>
        }
        <ng-template #siteTemplate let-item>
          @if (item?.key === 0) {
            <div>Create New Site</div>
          } @else {
            <div>
              <div class="fw-medium">
                {{ item?.company_name }} [{{ item?.company?.company_name }}]
              </div>
              <div class="small-font text-secondary">
                {{ item?.address?.full_address }}
              </div>
            </div>
          }
        </ng-template>
      }

      <!-- Step 2: Assign to Guard -->
      @if (currentStep === 2) {
        <div class="row row-cols-2 mb-2">
          <div class="col">
            <button
              type="button"
              class="btn btn-lg btn-dark w-100"
              (click)="currentStep = 1; assigneeList = []"
            >
              Back
            </button>
          </div>
          <div class="col">
            <button
              type="button"
              class="btn btn-lg btn-primary w-100"
              (click)="currentStep = 3"
            >
              Next
            </button>
          </div>
        </div>
        @if (selectedJobType.enable_assignees === true) {
          @if (
            otherJobType.assignee.data?.id && !otherJobType.assignee?.search
          ) {
            <div>
              <dl>
                <div class="d-flex align-items-center">
                  <div class="flex-grow-1">
                    <dt>Assigned To</dt>
                    <dd (click)="editField('assignee')" class="link-edit">
                      {{ formdata.value.assigneeName }}
                    </dd>
                  </div>
                </div>
              </dl>
            </div>
          }
          @if (
            !otherJobType.assignee.data?.id || otherJobType.assignee?.search
          ) {
            <div>
              <gtapp-auto-complete
                [data]="assigneeList"
                placeHolder="Assign To"
                searchKeyword="full_name"
                [initialValue]="formdata.value.assigneeName"
                [itemTemplate]="assigneeTemplate"
                (inputChanged)="onAssigneeSearch($event)"
                (selected)="onAssigneeSelect($event)"
                (blurTriggered)="blurTriggered('assignee')"
                [enableCloseOption]="true"
                (fieldCleared)="editField('assignee')"
                [inputId]="'assigneeId'"
              >
              </gtapp-auto-complete>
              <ng-template #assigneeTemplate let-item>
                <div class="d-flex gap-2 flex-wrap">
                  <span>
                    {{ item?.full_name }}
                  </span>
                  @if (item?.access_status === 2) {
                    <div
                      class="text-warning-emphasis small-font bg-white rounded my-auto border px-2 fw-semibold"
                    >
                      Casual
                    </div>
                  }
                  @if (
                    selectedSiteExtraDetails?.preferred_user_ids?.includes(
                      item?.id
                    )
                  ) {
                    <div
                      class="text-success-emphasis small-font bg-white rounded my-auto border px-2 fw-semibold"
                    >
                      Preferred
                    </div>
                  }
                </div>
                @if (selectedSiteExtraDetails?.last_assignees?.[item?.id]) {
                  <div class="small text-secondary">
                    Previously Assigned:
                    @if (
                      (selectedSiteExtraDetails?.last_assignees?.[item?.id]
                        | misc: "getXDaysAgo") > 1
                    ) {
                      {{
                        selectedSiteExtraDetails?.last_assignees?.[item?.id]
                          | misc: "getXDaysAgo"
                      }}
                      day(s) ago |
                    } @else {}
                    {{
                      selectedSiteExtraDetails?.last_assignees?.[item?.id]
                        | misc: "eventDateGrouping"
                    }}
                  </div>
                }
                @if (item?.subcontractors?.length) {
                  <div class="small text-secondary">
                    🟧Subcontractor:
                    <span class="subcontractor-name">{{
                      item?.subcontractors
                    }}</span>
                  </div>
                }
              </ng-template>
            </div>
          }
        }
      }

      <!-- Step 3: Additional Info -->
      @if (currentStep === 3) {
        <div class="row row-cols-2 mb-2">
          <div class="col">
            <button
              type="button"
              class="btn btn-lg btn-dark w-100"
              (click)="currentStep = 2"
            >
              Back
            </button>
          </div>
          <div class="col">
            <button
              type="button"
              class="btn btn-lg btn-primary w-100"
              (click)="currentStep = 5; formatScheduleForm()"
            >
              Next
            </button>
          </div>
        </div>
        @if (selectedJobType?.type_identity === 2) {
          <!--https://app.shortcut.com/sendem/story/13913/add-positions-to-static-shifts -->
          <!--https://app.shortcut.com/sendem/story/13916/add-job-number-for-static-guards-shifts-->
          <div class="mb-3 row row-cols-1 row-cols-lg-2">
            <div class="col">
              <div class="input-group">
                <div class="form-floating">
                  <input
                    class="form-control"
                    id="jobNumberField"
                    type="text"
                    placeholder="Job Number"
                    formControlName="externalJobId"
                    autocomplete="off"
                  />
                  <label>Job Number</label>
                </div>
                @if (formdata.value?.externalJobId) {
                  <span
                    class="input-group-text"
                    (click)="
                      formdata.controls['externalJobId'].setValue('');
                      shiftFocus('externalJobIdField')
                    "
                  >
                    <i class="fa-solid fa-xmark"></i>
                  </span>
                }
              </div>
            </div>
            <div class="col">
              <div class="input-group">
                <div class="form-floating">
                  <input
                    class="form-control"
                    id="positionField"
                    type="text"
                    placeholder="Shift Position"
                    formControlName="position"
                    autocomplete="off"
                  />
                  <label>Shift Position</label>
                </div>
                @if (formdata.value?.position) {
                  <span
                    class="input-group-text"
                    (click)="
                      formdata.controls['position'].setValue('');
                      shiftFocus('positionField')
                    "
                  >
                    <i class="fa-solid fa-xmark"></i>
                  </span>
                }
              </div>
            </div>
          </div>
        }
        <div class="mb-3 row row-cols-1 row-cols-lg-2">
          <div class="col">
            <div class="form-group input-group">
              <textarea
                class="form-control"
                placeholder="Additional Information"
                rows="5"
                wrap="hard"
                maxlength="900"
                type="text"
                autofocus
                [(ngModel)]="otherJobType.ai.value"
                formControlName="requestDetail"
                id="aiTextBox"
              ></textarea>
              @if (otherJobType?.ai?.value) {
                <span
                  class="input-group-text"
                  (click)="
                    otherJobType.ai.value = '';
                    formdata.controls['requestDetail'].setValue('');
                    shiftFocus('aiTextBox')
                  "
                >
                  <i class="fa-solid fa-xmark"></i>
                </span>
              }
            </div>
          </div>
          <div class="col">
            <div class="form-group input-group">
              <textarea
                class="form-control"
                placeholder="Internal Notes (Will not be shown on reports)"
                rows="5"
                wrap="hard"
                maxlength="900"
                type="text"
                autofocus
                [(ngModel)]="otherJobType.in.value"
                formControlName="internal_notes"
                id="inTextBox"
              ></textarea>
              @if (otherJobType?.in?.value) {
                <span
                  class="input-group-text"
                  (click)="
                    otherJobType.in.value = '';
                    formdata.controls['internal_notes'].setValue('');
                    shiftFocus('inTextBox')
                  "
                >
                  <i class="fa-solid fa-xmark"></i>
                </span>
              }
            </div>
          </div>
        </div>
      }

      <!-- Step 4: Geofence Alert -->
      @if (currentStep === 4) {
        <div class="row row-cols-2 mb-2">
          <div class="col">
            <button
              type="button"
              class="btn btn-lg btn-dark w-100"
              (click)="currentStep = 3"
            >
              Back
            </button>
          </div>
          <div class="col">
            <button
              type="button"
              class="btn btn-lg btn-primary w-100"
              (click)="formatScheduleForm(); currentStep = 5"
            >
              Next
            </button>
          </div>
        </div>
        <div>
          <!-- <button
              class="btn btn-danger btn-lg w-100 mb-2"
            (click)="
              enableGeofencing = !enableGeofencing;
              additionalInfo.geofence_distance = 0
            "
              >
              {{ enableGeofencing ? "Remove Geofence" : "Add Geofence" }}
            </button> -->
        </div>
        @if (enableGeofencing) {
          <ng-container>
            <gtapp-map-leaflet
              [latLon]="{
                lat:
                  otherJobType.site?.data?.address?.latitude ||
                  otherJobType?.site?.data?.gps?.lat,
                lon:
                  otherJobType.site?.data?.address?.longitude ||
                  otherJobType?.site?.data?.gps?.lon,
              }"
              mapId="smallMapOtherJob"
              [changableRadius]="true"
              [mapRadiusParams]="{
                minKm: 0,
                maxKm: 5000,
                nearestKmValue: 0,
              }"
              (updateMinDistance)="updateMinDistance($event)"
            ></gtapp-map-leaflet>
          </ng-container>
        } @else {
          <ng-container>
            <gtapp-map-leaflet
              [latLon]="{
                lat:
                  otherJobType.site?.data?.address?.latitude ||
                  otherJobType?.site?.data?.gps?.lat,
                lon:
                  otherJobType.site?.data?.address?.longitude ||
                  otherJobType?.site?.data?.gps?.lon,
              }"
              mapId="smallMapOtherJobNormal"
            ></gtapp-map-leaflet>
          </ng-container>
        }
      }

      <!-- Step 5: Schedule Time? -->
      @if (currentStep === 5) {
        <div class="row row-cols-2 mb-5 mb-lg-4">
          <div class="col">
            <button
              type="button"
              class="btn btn-lg btn-dark w-100"
              (click)="currentStep = 3; saveCurrentSchedule()"
            >
              Back
            </button>
          </div>
          <div class="col">
            <button
              type="button"
              class="btn btn-primary btn-lg w-100"
              (click)="onAddJob()"
              [disabled]="addJobPressed || !schedulerForm.valid"
            >
              Add Job
            </button>
          </div>
        </div>
        @if (scheduleStepperActive) {
          <gtapp-scheduler
            [dialogBox]="false"
            [schedulerForm]="schedulerForm"
            [editSchedule]="true"
          ></gtapp-scheduler>
        }
        <div class="mt-4 form-floating">
          <select
            class="form-select"
            (click)="getIntervalData()"
            [ngModel]="intervalCheck"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="updateInterval($event)"
            placeholder="Welfare Check Interval"
          >
            @for (interval of intervalData; track interval) {
              <option [ngValue]="interval.value">
                {{ interval.name }}
              </option>
            }
          </select>
          <label for="">Welfare Check Interval</label>
        </div>
        @if (intervalCheck) {
          <div class="alert">
            <div>
              Guards will be reminded to submit a welfare check
              <span class="fw-bold">
                {{ welfareReminderDict?.[intervalCheck] }} minutes before</span
              >
              the interval set above.
            </div>
            <div>
              Maximum inactivity time allowed before a missed welfare check is
              recorded:
              <span class="fst-italic fw-bold">
                {{ intervalCheck }} minutes.
              </span>
            </div>
          </div>
        }
      }
    </form>
  </div>

  @if (
    (otherJobType.site?.data?.address?.latitude ||
      otherJobType?.site?.data?.gps?.lat) &&
    largeView
  ) {
    <div class="col">
      <div>
        <!-- <button
                class="btn btn-danger btn-lg w-50 mb-2"
        (click)="
          enableGeofencing = !enableGeofencing;
          additionalInfo.geofence_distance = 0
        "
                >
                {{ enableGeofencing ? "Remove Geofence" : "Add Geofence" }}
              </button> -->
      </div>
      @if (enableGeofencing) {
        <ng-container>
          <gtapp-map-leaflet
            [latLon]="{
              lat:
                otherJobType.site?.data?.address?.latitude ||
                otherJobType?.site?.data?.gps?.lat,
              lon:
                otherJobType.site?.data?.address?.longitude ||
                otherJobType?.site?.data?.gps?.lon,
            }"
            mapId="largeMapOtherJob"
            [changableRadius]="true"
            [mapRadiusParams]="{
              minKm: 0,
              maxKm: 5000,
              nearestKmValue: 0,
            }"
            (updateMinDistance)="updateMinDistance($event)"
          ></gtapp-map-leaflet>
        </ng-container>
      } @else {
        <ng-container>
          <gtapp-map-leaflet
            [latLon]="{
              lat:
                otherJobType.site?.data?.address?.latitude ||
                otherJobType?.site?.data?.gps?.lat,
              lon:
                otherJobType.site?.data?.address?.longitude ||
                otherJobType?.site?.data?.gps?.lon,
            }"
            mapId="largeMapOtherJobNormal"
          ></gtapp-map-leaflet>
        </ng-container>
      }
    </div>
  }
</div>
